<nz-drawer
  [nzClosable]="true"
  [nzMaskStyle]="maskObj"
  [nzWidth]="896"
  [nzVisible]="showPopup"
  [nzTitle]="resTitle"
  [nzBodyStyle]="styleObj"
  [nzWrapClassName]="'research-popup-drawer'"
  (nzOnClose)="closeModal()"
>
  <ng-template #resTitle>
    <div class="header">
      <span>Research Snippets </span>
    </div>
    <div class="sub-eader">
      <span>Selected line item: </span><span>{{ lineItemName }}</span>
    </div>
  </ng-template>
  <ng-container *nzDrawerContent>
    <div class="research-popup">
      <div class="reports-container">
        <div class="documents-container">
          <div class="result-div">
            <span>Reports Found : {{ totalReports }} </span>
          </div>
          <!-- run for loop to make list, and infinite scroll here -->
          <div
            infiniteScroll
            [infiniteScrollDistance]="2"
            [infiniteScrollThrottle]="50"
            (scrolled)="onScroll()"
            [scrollWindow]="false"
            [infiniteScrollContainer]="'.documents-list'"
          >
            <div class="documents-list">
              <ng-container *ngIf="loading">
                <ul>
                  <li *ngFor="let dummySection of [0, 1, 2, 3, 4, 5, 6, 7]">
                    <nz-skeleton
                      [nzTitle]="true"
                      [nzActive]="true"
                      [nzParagraph]="false"
                    ></nz-skeleton>
                  </li>
                </ul>
              </ng-container>
              <ng-container *ngFor="let data of documentsList; index as i">
                <section *ngIf="!loading" (click)="selectDocument(data)">
                  <div
                    class="document-item"
                    [ngClass]="{
                      selected: data.document_id === currentDocument.document_id
                    }"
                  >
                    <div class="title" nz-tooltip [nzTooltipTitle]="data.title">
                      <span class="index">{{ i + 1 }}.</span>
                      <span class="title-text">{{
                        data.title | textEllipsis: 100
                      }}</span>
                    </div>
                    <div class="details">
                      <div class="first-row">
                        <span class="bold">Date published : </span
                        ><span>{{
                          data.publish_date | date: "dd-MMM-yyyy"
                        }}</span>
                        <div class="sentence-instance-count">
                          <span *ngIf="data.sentence_hits != 1"
                            >{{ data.sentence_hits }} SENTENCES</span
                          >
                          <span *ngIf="data.sentence_hits == 1"
                            >{{ data.sentence_hits }} SENTENCE</span
                          >
                        </div>
                      </div>
                      <div class="second-row">
                        <span class="bold">Published by : </span
                        ><span
                          >{{ data.analyst_name }} |
                          {{ data.broker_name }}</span
                        >
                      </div>
                    </div>
                  </div>
                </section>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="sentences-list">
          <!-- run for loop to make sentence instances -->
          <ng-container *ngIf="loadingSentences">
            <div class="sentence-result">
              <ul>
                <li
                  *ngFor="
                    let dummySection of [
                      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13
                    ]
                  "
                >
                  <nz-skeleton
                    [nzTitle]="true"
                    [nzActive]="true"
                    [nzParagraph]="false"
                  ></nz-skeleton>
                </li>
              </ul>
            </div>
          </ng-container>

          <ng-container *ngIf="!loadingSentences">
            <div class="sentence-result">
              <span class="count" *ngIf="sentencesList.length > 1"
                >{{ sentencesList.length }} Sentences Found</span
              >
              <span class="count" *ngIf="sentencesList.length == 1"
                >{{ sentencesList.length }} Sentence Found</span
              >
              <span class="report-link">
                <a target="_blank" href="{{ currentDocumentLink }}"
                  >View Full Report</a
                ></span
              >
            </div>
            <div *ngFor="let data of sentencesList; index as i">
              <section class="sentence-item">
                <div class="instance-count">
                  <span>{{ i + 1 }} of {{ sentencesList.length }}</span>
                </div>
                <div class="instance-text">
                  <p nz-paragraph nzEllipsis nzExpandable [nzEllipsisRows]="2">
                    {{ data.sentence_text }}
                  </p>
                </div>

                <div class="footer">
                  <div class="question">
                    <span>Is this sentence applicable?</span>
                  </div>
                  <div class="buttons">
                    <button
                      nz-button
                      nzType="default"
                      class="btn clear-btn"
                      [ngClass]="{ 'va-button--disabled': !data.showClear }"
                      (click)="clearSelection(data.sentence_id)"
                    >
                      Undo
                    </button>

                    <button
                      nz-button
                      nzType="default"
                      class="btn yes-btn"
                      [ngClass]="{
                        'va-button--disabled': data.showClear,
                        'va-button--selected': data.optionSelected === 'Yes'
                      }"
                      (click)="setYes(data.sentence_id)"
                    >
                      <va-icon
                        size="small"
                        name="check"
                        class="va-button-icon"
                        *ngIf="data.optionSelected === 'Yes'"
                      ></va-icon>
                      <span>Yes</span>
                    </button>

                    <button
                      nz-button
                      nzType="default"
                      class="btn no-btn"
                      [ngClass]="{
                        'va-button--disabled': data.showClear,
                        'va-button--selected': data.optionSelected === 'No'
                      }"
                      (click)="setNo(data.sentence_id)"
                    >
                      <va-icon
                        size="small"
                        name="close"
                        class="va-button-icon"
                        *ngIf="data.optionSelected === 'No'"
                      ></va-icon>
                      <span>No</span>
                    </button>
                  </div>
                </div>
              </section>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>
</nz-drawer>
